import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as getters from "./getters";
import mutations from "./mutations";
/*import createLogger from '../plugins/logger'*/
import Constant from "@/Constant";

//modules
import login from "./modules/login/index";
import home from "./modules/home/index";
import cart from "./modules/cart/index";
import classify from "./modules/classify/index";
import personal from "./modules/personal/index";
import plysicalStores from "./modules/physicalStores/index";
import agency from "./modules/agency/index";
import agencyCom from "./modules/agency/agencyCom";
import customOrder from "./modules/customOrder/index";
import questions from "./modules/questions/index";
import customerService from "./modules/customerService/index";
import afterSaleComment from "./modules/afterSaleComment/index";

import diy from "./modules/diy/index"; //diy部分内容
import fitting from "./modules/fitting/index";
import installStudy from "./modules/install-study/index";
import prodIntro from "./modules/prod-intro/index";

Vue.use(Vuex);
const debug =
  process.env.NODE_ENV !== "production" && Constant.env.STORE_LOG_SWITCH;

//公共数据
const state = {
  userAttrId: "", //用户sessionId
  userInfo: null, //用户信息
  customerLink: null, //客服链接
};

//导出STORE
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    login,
    home,
    cart,
    classify,
    personal,
    plysicalStores,
    agency,
    agencyCom,
    customOrder,
    questions,
    customerService,
    afterSaleComment,
    fitting,
    diy,
    installStudy,
    prodIntro,
  },
  strict: debug,
  /*plugins: debug ? [createLogger()] : []*/
});



// WEBPACK FOOTER //
// ./src/store/index.js